import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/fastvaluedeal-reviewer';

const html = `
<div
  class="fvd-reviewer-content container"
  data-attribute="fvd-reviewer-content"
  data-image-position="left"
  data-background-content-color="#F6F8FF"
  data-border-color="#E5E7EB"
>
  <div class="fvd-reviewer__image" data-attribute="fvd-reviewer__image">
    <img
      data-attribute="fvd-reviewer__image-img"
      src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e985402016af51e9494f3.avif?w=500&h=50&q=80"
      alt="reviewer"
    />
  </div>
  <div class="fvd-reviewer__info" data-attribute="fvd-reviewer__info">
    <div class="fvd-reviewer__info-quote-start" data-attribute="fvd-reviewer__info-quote-start">
      <img
        data-attribute="fvd-reviewer__info-quote-start-img"
        data-show="true"
        src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e986d92df0a8b7df99a65.png?w=100&h=50&q=80"
        alt="Quotation"
      />
    </div>
    <div class="fvd-reviewer__text" data-attribute="fvd-reviewer__text">
      <p style="text-align: center">
        <em>
          This device has caused quite the stir in the cable industry. Working there myself has shown me just how much
          better WaveMax is than regular cable TV. I recommend everyone to get it before it's off the market forever.
        </em>
      </p>
    </div>
    <div class="fvd-reviewer__author" data-attribute="fvd-reviewer__author">
      <p class="fvd-reviewer__author-name" data-attribute="fvd-reviewer__author-name">Connor Smith</p>
      <img
        class="fvd-reviewer__author-signature"
        data-attribute="fvd-reviewer__author-signature"
        data-show="true"
        src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e988cf57756783fcba68b.png?w=200&h=50&q=80"
        alt="signature"
      />
    </div>
    <div class="fvd-reviewer__info-quote-end" data-attribute="fvd-reviewer__info-quote-end">
      <img
        data-attribute="fvd-reviewer__info-quote-end-img"
        data-show="true"
        src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e98819329b477195e982d.png?w=100&h=50&q=80"
        alt="Quotation"
      />
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
